export const GET_SPONSORS_LIST_LOADING = "GET_SPONSORS_LIST_LOADING";
export const SET_SPONSORS_LIST = "SET_SPONSORS_LIST";
export const ADD_SPONSOR_LOADING = "ADD_SPONSOR_LOADING";
export const GET_SPONSOR_DETAILS_LOADING = "GET_SPONSOR_DETAILS_LOADING";
export const SET_SPONSOR_DETAILS = "SET_SPONSOR_DETAILS";
export const DELETE_SPONSOR_LOADING = "DELETE_SPONSOR_LOADING";
